import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, FormGroup } from 'react-bootstrap'
import { useStateValue } from '../state'

const NewExceptionGrantModal = props => {
  const [radioValue, setRadioValue] = useState(true)
  const [grantExtraTime, increaseGrantExtraTime] = useState(1)
  const [, dispatch] = useStateValue()

  return (
    <Modal show={props.show} onHide={() => props.toggle(!props.show)}>
      <Modal.Header>
        <Modal.Title>Grant Extra Time</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup>
          <div>
            <label className="pt-4 pr-3 pb-4">
              <input
                name={props.name}
                type="radio"
                value={false}
                checked={!radioValue}
                onChange={() => {
                  setRadioValue(false)
                }}
              />
              &nbsp;Remove Time Limit
            </label>
          </div>
          <div>
            <label>
              <input
                name={props.name}
                type="radio"
                checked={radioValue}
                onChange={() => {
                  setRadioValue(true)
                }}
              />
              &nbsp;Increase Time Limit
            </label>
            {radioValue && (
              <div className="pt-3 pr-3 pl-4">
                Increase time limits on selected assessments.
                <div>
                  <label htmlFor="shiftDaysInput" className="pt-3 pr-4 h5">
                    Minutes
                  </label>
                </div>
                <input
                  type="number"
                  className="form-control"
                  value={grantExtraTime}
                  id="extraTimeInput"
                  step={1}
                  min={1}
                  onChange={e => {
                    increaseGrantExtraTime(e.currentTarget.value)
                  }}
                />
              </div>
            )}
          </div>
        </FormGroup>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => {
            dispatch({
              type: 'updateExceptionType',
              exceptionType: 'grantExtraTime',
              extraTime: Number(grantExtraTime),
              override: !radioValue,
            })
            props.toggle(false)
          }}
          className="btn btn-myed btn-primary btn-primary-myed pull-right"
        >
          Ok
        </button>
        <button
          onClick={() => {
            props.toggle(false)
          }}
          className="btn btn-myed btn-default btn-default-myed pull-right mt-2"
        >
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default NewExceptionGrantModal

NewExceptionGrantModal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  name: PropTypes.string,
}
